<h1 mat-dialog-title>{{ 'photo_editor.modal.title' | translate }} - {{ data.file.filename }}</h1>
<button mat-icon-button
        class="close close-btn"
        [mat-dialog-close]=""
        tabindex="-1">
    <mat-icon class="dr-material-icon">clear</mat-icon>
</button>

<div mat-dialog-content>

    <smp-photo-editor-5 [idPrefix]="idPrefix"
                        [file]="data.file"
                        (export)="exportFile($event)"
                        (close)="close()">
    </smp-photo-editor-5>

</div>
